export default __webpack_public_path__ + "static/media/pool4.97e5f64b.jpeg";